import styled from 'styled-components';

export const Container = styled.div`
  padding: 0.5rem 1rem;
  min-width: 16.67rem;
  max-width: 22.22rem;

  h1 {
    padding: 1rem 0.5rem;
    font-family: 'RedHatDisplay-Bold';
    line-height: 1.28rem;
    color: #1e88e5;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 2px solid #1e88e5af;
  }
`;

export const NotificationList = styled.ul`
  margin-top: 0.5rem;
  max-height: 19.44rem; /* Altura aproximada para 5 notificações */
  overflow-y: auto;

  /* Estilo da barra de rolagem */
  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const NotificationItem = styled.li<{ $isClicked: boolean }>`
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0.67rem 0;
    background: transparent;
    border: none;
    text-align: left;
    cursor: ${props => (props.$isClicked ? 'pointer' : 'default')};
    transition: background-color 0.3s;

    &:hover {
      background-color: ${props => (props.$isClicked ? '#f5f5f5' : '#e1e1e1')};
    }
    img {
      width: 1.33rem;
      height: 1.33rem;
      margin-right: 0.67rem;
    }

    div {
      flex: 1;
      position: relative;
      p {
        margin: 0;
        font-size: 0.8rem;
        line-height: 1.4;
        text-align: left;
        > b {
          font-family: 'RedHatDisplay-Bold';
          font-size: 0.8rem;
        }
      }
    }
  }
`;

export const NotificationTime = styled.span`
  position: absolute;
  margin-right: 0.3rem;
  bottom: -0.67rem;
  right: 0;
  font-size: 0.67rem;
  color: #6c757d;
  font-style: italic;
`;
